import React, { useState } from 'react';

const helpTickets = [
  { id: 'HLP-001', subject: 'Membership renewal not processing',     status: 'Open',        priority: 'High',   date: 'Apr 20, 2025' },
  { id: 'HLP-002', subject: 'Unable to register for showcase event', status: 'Resolved',    priority: 'Medium', date: 'Apr 15, 2025' },
  { id: 'HLP-003', subject: 'Invoice discrepancy for March payment', status: 'In Progress', priority: 'Low',    date: 'Apr 10, 2025' },
];

const statusBadgeClass = {
  Open:          'badge-danger text-red',
  Resolved:      'badge-success color-green1-dark',
  'In Progress': 'empty-badge-lite-yellow color-brown1-dark',
};
const priorityClass = { High: 'red', Medium: 'color-yellow1-dark', Low: 'lgrey' };

const SectionCard = ({ children, extraClass = '' }) => (
  <div className={`bg-white brd-10 shadow-small p-20 m-b-20 ${extraClass}`}>{children}</div>
);

const CardHeader = ({ title, action, onAction }) => (
  <div className="flex justspacebetween aligncenter m-b-15">
    <span className="fw700 font-15 color-black">{title}</span>
    {action && <span className="font-12 highlight pointer fw500" onClick={onAction}>{action}</span>}
  </div>
);

const GreenBtn = ({ label = 'View', onClick, extraClass = '' }) => (
  <button className={`btn-primary bg-green1-dark text-white brd-5 font-12 fw500 p-5-10 ${extraClass}`} onClick={onClick}>
    {label}
  </button>
);

const SupportTab = () => {
  const [helpForm, setHelpForm] = useState({ subject: '', message: '', priority: 'Medium' });
  const [helpDone, setHelpDone] = useState(false);

  return (
    <>
      <SectionCard>
        <CardHeader title="Submit a Support Request" />
        {helpDone ? (
          <div className="text-center p-20">
            <i className="fas fa-check-circle f40 green m-b-10 d-block"></i>
            <div className="fw700 font-18 dark-navy">Request Submitted!</div>
            <div className="lgrey m-t-5">Our team will respond within 24 hours.</div>
            <GreenBtn label="Submit Another" onClick={() => setHelpDone(false)} extraClass="m-t-15" />
          </div>
        ) : (
          <div className="flex coldir gap-15">
            <div>
              <label className="font-12 fw700 lgrey text-upp ls-1 d-block m-b-5">Subject</label>
              <input className="form-input form-input-gray form-input-full p-10"
                value={helpForm.subject}
                onChange={e => setHelpForm(f => ({ ...f, subject: e.target.value }))}
                placeholder="Describe your issue briefly..." />
            </div>
            <div>
              <label className="font-12 fw700 lgrey text-upp ls-1 d-block m-b-5">Priority</label>
              <select className="form-select-dropdown" value={helpForm.priority}
                onChange={e => setHelpForm(f => ({ ...f, priority: e.target.value }))}>
                {['Low', 'Medium', 'High'].map(p => <option key={p}>{p}</option>)}
              </select>
            </div>
            <div>
              <label className="font-12 fw700 lgrey text-upp ls-1 d-block m-b-5">Message</label>
              <textarea className="form-input form-input-gray form-input-full form-text-area p-10"
                rows={4} value={helpForm.message}
                onChange={e => setHelpForm(f => ({ ...f, message: e.target.value }))}
                placeholder="Please describe the issue in detail..." />
            </div>
            <button
              className={`btn-primary bg-green1-dark text-white brd-5 font-14 fw500 p-10 p-l-20 p-r-20 ${!helpForm.subject ? 'op-50' : ''}`}
              onClick={() => helpForm.subject && setHelpDone(true)}>
              Submit Request
            </button>
          </div>
        )}
      </SectionCard>

      <SectionCard>
        <CardHeader title="Your Tickets" />
        <div className="table-responsive">
          <table className="table shadow-small">
            <thead><tr>{['Ticket ID', 'Subject', 'Priority', 'Status', 'Date'].map(h => <th key={h}>{h}</th>)}</tr></thead>
            <tbody>
              {helpTickets.map((t, i) => (
                <tr key={i}>
                  <td className="highlight fw700">{t.id}</td>
                  <td>{t.subject}</td>
                  <td><span className={`fw700 ${priorityClass[t.priority]}`}>{t.priority}</span></td>
                  <td><span className={`badge brd-30 font-12 fw700 ${statusBadgeClass[t.status]}`}>{t.status}</span></td>
                  <td className="lgrey">{t.date}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </SectionCard>
    </>
  );
};

export default SupportTab;